import React from 'react'
import { Load, Logo } from './Shapes'
import { appLoader } from './../styles/'

export default ({transition}) => (
 <div className={appLoader(transition)}>
   <div className="loader--inner">
      <Logo width="359" height="28" />
      <p>Brand Center</p>
      <Load width="50" height="50" />
   </div>
 </div>
)



// WEBPACK FOOTER //
// ./src/components/Loader.js